import { PageHero } from "@/components/PageHero";
import { Reveal, Kicker } from "@/components/Reveal";
import { CTABand } from "@/components/CTABand";

const PROGRAMS = [
  { name: "Art & Cuppa with Aunties", desc: "Relaxed creative community spaces for connection, storytelling and yarning — no referral needed, no agenda beyond being together." },
  { name: "Community Cook-Up", desc: "Food, conversation, practical skills and intergenerational connection around a shared table." },
  { name: "Yarning Circles", desc: "Facilitated spaces for people to share experiences, witness each other's stories and build collective knowledge." },
  { name: "Community Movement", desc: "Walking, outdoor activities and group fitness as opportunities for connection, regulation and belonging." },
];

const GOAL = ["Community", "Relationships", "Culture", "Identity", "Knowledge", "Belonging"];

const Community = () => (
  <div data-testid="community-page">
    <PageHero
      kicker="Community Programs"
      title={"Community building is\npart of the intervention."}
      lede="The long-term goal is not for a child to become dependent upon a service. It is to strengthen the community, relationships, culture, identity, knowledge and belonging around them."
    />

    <section className="px-6 py-14 sm:py-20 bg-cream">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-6">
        {PROGRAMS.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.07}>
            <div data-testid={`community-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className={`rounded-[36px] p-10 h-full transition-transform duration-500 hover:-translate-y-2 ${i === 0 ? "bg-terracotta text-cream" : i === 3 ? "bg-charcoal text-cream" : "bg-creamdark border border-ochre/25 text-charcoal"}`}>
              <span className="font-display italic text-lg opacity-50">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-display text-3xl font-light">{p.name}</h3>
              <p className={`mt-4 text-sm leading-relaxed ${i === 0 || i === 3 ? "text-cream/80" : "text-earth/85"}`}>{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="px-6 pb-16 sm:pb-24 bg-cream">
      <Reveal>
        <div className="max-w-7xl mx-auto rounded-[48px] bg-blush/40 p-10 sm:p-16 grain relative overflow-hidden">
          <div className="absolute -bottom-24 -left-20 w-80 h-80 bg-ochre/20 organic-blob blur-2xl" />
          <div className="relative">
            <Kicker>The long-term goal</Kicker>
            <p className="font-display font-light text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-snug max-w-4xl">
              {GOAL.map((g, i) => (
                <span key={g}>
                  <span className={i % 2 ? "italic text-terracotta" : ""}>{g}</span>
                  {i < GOAL.length - 1 && <span className="text-ochre"> + </span>}
                </span>
              ))}
              <span className="block mt-3 text-2xl sm:text-3xl text-earth">around every child.</span>
            </p>
          </div>
        </div>
      </Reveal>
    </section>

    <CTABand
      title="Community programs will be shaped by community. Come and have your say."
      primary={{ to: "/consultation", label: "Join a Community Yarn" }}
      secondary={{ to: "/programs", label: "See All Programs" }}
    />
  </div>
);

export default Community;
